class CheckoutActiveErrorModal extends Modal {
    constructor() {
        super();
        this.acceptButton = this.querySelector('[data-checkout-active-error-accept]');
        this.checkoutButton = this.querySelector('[data-checkout-active-error-checkout]');
    }

    connectedCallback() {
        this.acceptButton.addEventListener('click', this.handleAccept.bind(this));
        this.checkoutButton.addEventListener('click', this.handleCheckout.bind(this));
    }

    disconnectedCallback() {
        this.acceptButton.removeEventListener('click', this.handleAccept.bind(this));
        this.checkoutButton.removeEventListener('click', this.handleCheckout.bind(this));
    }

    handleCheckout() {
        this.acceptButton.disabled = true;
        this.acceptButton.setAttribute('aria-disabled', 'true');
        this.checkoutButton.disabled = true;
        this.checkoutButton.setAttribute('aria-disabled', 'true');
        this.checkoutButton.classList.add('is-loading');
        window.location.href = '/cart';
    }

    handleAccept() {
        super.close();
    }

    close(evt) {
        if (evt == undefined) return;
        super.close(evt);
    }
}

customElements.define('checkout-error-active-modal', CheckoutActiveErrorModal);